import { createContext, useContext } from 'react';

// Shared with DrilldownContext.jsx, which provides the value and holds the
// pending-request state. Split into its own file for the same react-refresh
// reason as useToast.js/useConfirm.js — a component file should export
// components only.
export const DrilldownCtx = createContext(null);

export function useDrilldown() {
  const ctx = useContext(DrilldownCtx);
  if (!ctx) throw new Error('useDrilldown must be used within a DrilldownProvider');
  return ctx;
}

/**
 * The same context, `null` outside a provider instead of throwing.
 *
 * For a view where drilling is an ENHANCEMENT rather than the point. The
 * accounting statements throw, correctly: a trial balance row you cannot
 * click is a broken trial balance, and failing at mount is better than
 * shipping one. A chart is the other case — it is a chart first, and it is
 * mounted in places that have no provider and no business having one: its
 * own unit tests, and a headless render of a slide.
 *
 * A caller MUST treat null as "drilling is off here" and render a
 * non-interactive mark, rather than rendering a control that does nothing.
 */
export function useOptionalDrilldown() {
  return useContext(DrilldownCtx);
}
